import MultipleTravelClassesListContainer from '../../../../components/containers/MultipleTravelClassesListContainer';
import preloadCustomProps from '../../../utils/preloads/preloadFaresGridBackgroundImage';
import deepmerge from '../../../utils/deepmerge';

const cmpConfig = {
  name: 'multiple-travel-classes',
  moduleId: 'em-cmp-lib-airmodules',
  staticAssetsHost: 'https://em-frontend-assets.airtrfx.com',
  version: 'NO_NEEDED',
  containerConfig: {
    settings: {
      instance: MultipleTravelClassesListContainer
    }
  },
  hooks: {
    params: {},
    preloadCustomProps
  }
};

const finalConfig = deepmerge(cmpConfig, {});

export default finalConfig;
